/**
 * @generated SignedSource<<7a588661969e06150176026a22c06abb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FeedbackCardActionsDismissRequestMutation$variables = {
  id: string;
};
export type FeedbackCardActionsDismissRequestMutation$data = {
  readonly dismissRequest: {
    readonly feedbackAndRequestsEdge: {
      readonly node: {
        readonly cancelledByUser?: boolean;
        readonly id?: string;
        readonly isArchived?: boolean;
      };
    };
  } | null;
};
export type FeedbackCardActionsDismissRequestMutation = {
  response: FeedbackCardActionsDismissRequestMutation$data;
  variables: FeedbackCardActionsDismissRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelledByUser",
      "storageKey": null
    }
  ],
  "type": "FeedbackRequestNode",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackCardActionsDismissRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DismissRequest",
        "kind": "LinkedField",
        "name": "dismissRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackAndRequestsEdge",
            "kind": "LinkedField",
            "name": "feedbackAndRequestsEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedbackCardActionsDismissRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DismissRequest",
        "kind": "LinkedField",
        "name": "dismissRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackAndRequestsEdge",
            "kind": "LinkedField",
            "name": "feedbackAndRequestsEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9003193c0cdea59b541de4aecc2c8c2a",
    "id": null,
    "metadata": {},
    "name": "FeedbackCardActionsDismissRequestMutation",
    "operationKind": "mutation",
    "text": "mutation FeedbackCardActionsDismissRequestMutation(\n  $id: ID!\n) {\n  dismissRequest(id: $id) {\n    feedbackAndRequestsEdge {\n      node {\n        __typename\n        ... on FeedbackRequestNode {\n          id\n          isArchived\n          cancelledByUser\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3e1d48acc1cd662fe2d331ca038aaa3a";

export default node;
